export default __webpack_public_path__ + "static/help-ac4b8fc1567d343e0bf8780bef4ca8dd.png";